
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/orders-and-payments",
      function () {
        return require("private-next-pages/account/orders-and-payments.js");
      }
    ]);
  